var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-list"},_vm._l((_vm.categories),function(category){return _c('CategoryListItem',{key:category.CODFAVORITO,attrs:{"category":category},on:{"CategorySelected":_vm.onCategorySelected}})}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76ea0637","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Categories/CategoryList.vue
// module id = null
// module chunks = 